<template>
  <div class="register-container">
    <div class="goback">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-arrow-left"></i>
          返回首页
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="register-box">
      <!-- 头部 -->
      <div class="register-header">
        <h2>黄梅水产 · 用户注册</h2>
        <!-- <p>欢迎使用渔链供应平台</p> -->
      </div>

      <!-- 表单内容 -->
      <div class="register-content">
        <el-form
          :model="registerForm"
          :rules="registerRules"
          ref="registerForm"
          label-width="110px"
          label-position="right">
          <!-- 用户类型选择 -->
          <div class="type-select-section">
            <label class="section-label">用户类型</label>
            <el-radio-group v-model="registerForm.sell_type" @change="handleTypeChange">
              <el-radio :label="1" border>个人</el-radio>
              <el-radio :label="2" border>个体户</el-radio>
              <el-radio :label="3" border>企业</el-radio>
            </el-radio-group>
          </div>

          <!-- 身份/企业信息 -->
          <div class="form-section">
            <div class="section-title">
              {{ registerForm.sell_type != 3 ? '身份信息' : '企业信息' }}
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="真实姓名" prop="name">
                  <el-input v-model="registerForm.name" placeholder="请输入真实姓名" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="身份证号" prop="id_code">
                  <el-input
                    v-model="registerForm.id_code"
                    placeholder="请输入身份证号"
                    prefix-icon="el-icon-postcard" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="联系人" prop="linker">
                  <el-input
                    v-model="registerForm.linker"
                    placeholder="请输入联系人"
                    prefix-icon="el-icon-user-solid" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  v-if="registerForm.sell_type != 1"
                  label="营业执照号码"
                  prop="business_license">
                  <el-input
                    v-model="registerForm.business_license"
                    placeholder="请输入营业执照号码"
                    prefix-icon="el-icon-document" />
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="地址" prop="address">
                  <el-input
                    v-model="registerForm.address"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入地址"
                    prefix-icon="el-icon-location-information" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 账号信息 -->
          <div class="form-section">
            <div class="section-title">账号信息</div>

            <el-row>
              <el-col :span="12">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input
                    v-model="registerForm.mobile"
                    placeholder="请输入手机号码"
                    prefix-icon="el-icon-mobile-phone" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="图形验证码" prop="code">
                  <div class="verify-code-wrapper">
                    <el-col :span="10">
                      <el-input
                        v-model="registerForm.code"
                        placeholder="请输入图形验证码"
                        prefix-icon="el-icon-key"
                        style="flex: 1" />
                    </el-col>
                    <img
                      class="verify-code-img"
                      @click="fetchVerifyCode"
                      :src="pic_url"
                      alt="验证码"
                      title="点击刷新" />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="短信验证码" prop="verify_code">
                  <div class="sms-code-wrapper">
                    <el-col :span="10">
                      <el-input
                        v-model="registerForm.verify_code"
                        placeholder="请输入短信验证码"
                        prefix-icon="el-icon-message"
                        style="flex: 1" />
                    </el-col>
                    <div>
                      <el-button
                        type="primary"
                        size="medium"
                        @click="fetchSmsCode"
                        :disabled="isSending">
                        {{ codeBtnText }}
                      </el-button>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="设置密码" prop="password">
                  <el-input
                    v-model="registerForm.password"
                    type="password"
                    placeholder="请设置密码（6-20位）"
                    prefix-icon="el-icon-lock"
                    show-password />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input
                    v-model="registerForm.confirmPassword"
                    type="password"
                    placeholder="请再次输入密码"
                    prefix-icon="el-icon-lock"
                    show-password />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 提示信息 -->
          <div class="tips-section">
            <el-alert title="填写真实信息可快速通过认证" type="info" :closable="false" show-icon>
              <template slot="default">
                <p style="margin: 5px 0">填写真实姓名和身份证号，注册后系统将自动进行身份核验</p>
                <p style="margin: 5px 0; color: #e6a23c">
                  核验通过后即可发布信息并查看他人联系方式
                </p>
              </template>
            </el-alert>
          </div>
        </el-form>

        <!-- 注册按钮 -->
        <div class="register-button">
          <el-button type="primary" :loading="loading" class="register-btn" @click="handleRegister">
            立即注册
          </el-button>
        </div>

        <!-- 底部链接 -->
        <div class="register-footer">
          <span>已有账号？</span>
          <el-button type="text" @click="goLogin">立即登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVerifyCode, sendSmsCode, submitRegister } from '@/api/register'

export default {
  name: 'Register',
  data() {
    return {
      pic_url: '',
      loading: false,
      isSending: false,
      codeBtnText: '获取验证码',
      timer: null,

      // 注册表单
      registerForm: {
        sell_type: 1,
        mobile: '',
        code: '',
        verify_code: '',
        password: '',
        confirmPassword: '',
        name: '',
        id_code: '',
        linker: '',
        business_license: '',
        address: ''
      },

      registerRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur'
          }
        ],
        code: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
        verify_code: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在6-20位之间', trigger: 'blur' }
        ],
        confirmPassword: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.registerForm.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
            required: true
          }
        ],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        id_code: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  created() {
    this.fetchVerifyCode()
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  methods: {
    // 切换用户类型
    handleTypeChange() {
      // 清空营业执照号码
      if (this.registerForm.sell_type === 1) {
        this.registerForm.business_license = ''
      }
    },

    // 获取图形验证码
    async fetchVerifyCode() {
      try {
        const res = await getVerifyCode()
        if (res.resultCode == 1) {
          // this.pic_url = res.resultInfo
          let img = res.resultInfo

          if (!img.startsWith('data:image')) {
            img = 'data:image/png;base64,' + img
          } else {
            img = img.replace(/data:image\/.*?;base64/, 'data:image/png;base64')
          }

          this.pic_url = img
        }
      } catch (error) {
        console.error('获取图形验证码失败', error)
      }
    },

    // 获取短信验证码
    async fetchSmsCode() {
      // 验证手机号
      if (!this.registerForm.mobile) {
        this.$message.warning('请先输入手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.registerForm.mobile)) {
        this.$message.warning('手机号格式不正确')
        return
      }
      if (!this.registerForm.code) {
        this.$message.warning('请先输入图形验证码')
        return
      }

      try {
        await sendSmsCode({
          mobile: this.registerForm.mobile,
          code: this.registerForm.code
        })

        this.$message.success('验证码已发送')

        // 倒计时
        this.isSending = true
        let seconds = 60
        this.codeBtnText = `${seconds}s后重发`
        this.timer = setInterval(() => {
          seconds--
          if (seconds <= 0) {
            clearInterval(this.timer)
            this.isSending = false
            this.codeBtnText = '获取验证码'
          } else {
            this.codeBtnText = `${seconds}s后重新获取`
          }
        }, 1000)
      } catch (error) {
        console.error('发送短信验证码失败', error)
        this.fetchVerifyCode()
      }
    },

    // 注册
    async handleRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (!valid) return

        this.loading = true

        try {
          const data = {
            sell_type: this.registerForm.sell_type,
            name: this.registerForm.name,
            address: this.registerForm.address,
            id_code: this.registerForm.id_code,
            linker: this.registerForm.linker,
            business_license: this.registerForm.business_license,
            mobile: this.registerForm.mobile,
            verify_code: this.registerForm.verify_code,
            password: this.registerForm.password
          }

          const res = await submitRegister(data)

          if (res.resultCode === 1) {
            this.$message.success('注册成功！正在跳转...')

            // 延迟跳转，让用户看到成功提示
            setTimeout(() => {
              const redirect = this.$route.query.redirect || '/'
              this.$router.push(redirect)

              // 打开登录弹窗
              this.$store.dispatch('authModal/openModal', { mode: 'login' })
            }, 1500)
          }
        } catch (error) {
          console.error('注册失败', error)
          this.$message.error(error.message || '注册失败，请稍后重试')
        } finally {
          this.loading = false
        }
      })
    },

    // 跳转登录
    goLogin() {
      this.$router.push('/')
      this.$store.dispatch('authModal/openModal', { mode: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  min-height: 100vh;
  background: rgb(224, 242, 247);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  position: relative;

  .goback {
    position: absolute;
    top: 20px;
    left: 20px;
    margin: 0;
    :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner, ) {
      font-size: 20px;
      cursor: pointer;
    }
  }

  .register-box {
    width: 100%;
    max-width: 1000px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .register-header {
      background: rgb(67, 175, 238);
      color: #fff;
      text-align: center;
      padding: 10px 10px;

      h2 {
        // margin: 0 0 10px 0;
        font-size: 28px;
        font-weight: 600;
      }

      p {
        margin: 0;
        font-size: 18px;
        opacity: 0.9;
      }
    }

    .register-content {
      padding: 10px 20px;

      .type-select-section {
        margin-bottom: 15px;
        text-align: center;

        .el-radio-button__inner,
        .el-radio-group {
          display: block;
          line-height: 1;
          vertical-align: middle;
        }

        .section-label {
          display: block;
          font-size: 20px;
          color: #606266;
          margin-bottom: 10px;
          font-weight: 500;
        }

        ::v-deep .el-radio.is-bordered {
          margin: 0 10px;
          padding: 12px 20px;

          &.is-checked {
            border-color: #667eea;

            .el-radio__label {
              color: #667eea;
            }
          }
        }
      }

      .form-section {
        .section-title {
          font-size: 20px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 15px;
          padding-bottom: 10px;
          border-bottom: 2px solid #667eea;
        }
      }

      .verify-code-wrapper {
        display: flex;
        gap: 10px;
        align-items: center;

        .verify-code-img {
          // width: 80px;
          height: 45px;
          cursor: pointer;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          transition: all 0.3s;

          &:hover {
            border-color: #667eea;
          }
        }
      }

      .sms-code-wrapper {
        display: flex;
        gap: 10px;

        .sms-btn {
          width: 120px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;

          &:hover {
            opacity: 0.9;
          }

          &.is-disabled {
            background: #f5f7fa;
            color: #c0c4cc;
          }
        }
      }

      .tips-section {
        margin-bottom: 15px;

        ::v-deep .el-alert {
          border-radius: 4px;
          justify-content: center;
          font-size: 18px;

          p {
            font-size: 13px;
          }
        }
      }

      .register-button {
        display: flex;
        justify-content: center;
        padding-top: 10px;

        .register-btn {
          width: 60%;
          height: 50px;
          font-size: 20px;
          background: rgb(2, 63, 194);
          border: none;

          &:hover {
            opacity: 0.9;
          }
        }
      }

      .register-footer {
        text-align: center;
        margin-top: 20px;
        color: #909399;
        font-size: 18px;

        span {
          margin-right: 5px;
        }

        ::v-deep .el-button--text {
          color: #667eea;
          padding: 0;

          &:hover {
            color: #764ba2;
          }
        }
      }
    }
  }
}

// 响应式
@media (max-width: 768px) {
  .register-container {
    padding: 20px 10px;

    .register-box {
      .register-content {
        padding: 30px 20px;
      }
    }
  }
}
</style>
